import Vue from "vue";
import Vuex from "vuex";
import state from "./state";
import mutations from "./mutations";
import loading from "./modules/loading";
import * as actions from "./actions";
import * as getters from "./getters"
/*import createPersistedState from 'vuex-persistedstate'*/

Vue.use(Vuex);

export default new Vuex.Store({
	state,
	getters,
	mutations,
	actions,
	modules: {
		loading
	}/*,
	plugins: [createPersistedState()]//会自动保存创建的状态。刷新还在*/
});


// WEBPACK FOOTER //
// ./src/store/index.js